import { Component } from '@angular/core';

@Component({
	templateUrl: './pagenotfound.component.html'
})
export class PagenotfoundComponent {}
